/* eslint  max-len: 0 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { authParams, getBase64Hash } from 'components/helpers/base64AuthParams';
import { userObj } from 'components/common/requestBody';
import translationKeys from 'translations/translationKeys';
import getLanguage from 'components/helpers/getLanguage';
import baseUrls from '../../config';

const apiBaseUrl = baseUrls.BASE_URL_API;
const apiVersion2 = baseUrls.API_VERSION2;
const client = axios.create({
  baseURL: apiBaseUrl,
});
const { msg29 } = translationKeys;
const lang = getLanguage();
const api = `/sport/event/topMatches/filter?markets=1&channel_id=${userObj.chl}&lang=${lang}`;
const signatureParam = `/sport/event/topMatches/filtermarkets=1&channel_id=${userObj.chl}&lang=${lang}`;
const url = `${apiBaseUrl}/${apiVersion2}${api}`;
export const getMeilleursParis = createAsyncThunk(
  'sports/getMeilleursParis',
  async (data, thunkAPI) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Content-Signature': `${authParams.username}:${getBase64Hash(`${authParams.username}/${apiVersion2}${signatureParam}${JSON.stringify(data)}`)}`,
        },
      };

      if (baseUrls.PARTNER_SLUG) {
        config.headers['X-Partner-Slug'] = baseUrls.PARTNER_SLUG;
      }
      const resp = await client.post(url, data, config);
      localStorage.setItem('savedData', JSON.stringify(data));
      localStorage.setItem('topMatchesFilter', JSON.stringify(resp.data));
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(msg29);
    }
  },
);

const initialState = {
  meilleursParis: [],
  filters: [],
  allsports: [],
  successTopMatches: false,
  isLoading: false,
  error: '',
};

const meilleursParisSlice = createSlice({
  name: 'meilleursParis',
  initialState,
  reducers: {
    selectItem: (state, { payload }) => {
      const updatedTopMatches = state.meilleursParis.map((match) => ({
        ...match,
        categories: match?.categories?.map((cat) => ({
          ...cat,
          tournaments: cat?.tournaments?.map((t) => ({
            ...t,
            matches: t?.matches?.map((m) => ({
              ...m,
              outcome: m?.outcome?.map((o) => (o.uniqueId === payload ? { ...o, inBetSlip: true } : o)),
            })),
          })),
        })),
      }));

      return {
        ...state,
        meilleursParis: updatedTopMatches,
        isLoading: false,
      };
    },
    resetMeilleurParis: (state) => ({
      ...state,
      ...initialState,
    }),
    unSelectFromTopmatch: (state, { payload }) => {
      const updatedTopMatches = state.meilleursParis.map((match) => ({
        ...match,
        categories: match?.categories?.map((cat) => ({
          ...cat,
          tournaments: cat?.tournaments?.map((t) => ({
            ...t,
            matches: t?.matches?.map((m) => ({
              ...m,
              outcome: m?.outcome?.map((o) => (o.uniqueId === payload ? { ...o, inBetSlip: false } : o)),
            })),
          })),
        })),
      }));

      return {
        ...state,
        meilleursParis: updatedTopMatches,
        isLoading: false,
      };
    },
    setAllToFalse: (state) => {
      const updatedTopMatches = state.meilleursParis.map((match) => ({
        ...match,
        categories: match?.categories?.map((cat) => ({
          ...cat,
          tournaments: cat?.tournaments?.map((t) => ({
            ...t,
            matches: t?.matches?.map((m) => ({
              ...m,
              outcome: m?.outcome?.map((outcome) => ({
                ...outcome,
                inBetSlip: false,
              })),
            })),
          })),
        })),
      }));

      return {
        ...state,
        meilleursParis: updatedTopMatches,
        isLoading: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMeilleursParis.pending, (state) => ({
        ...state,
        isLoading: true,
        successTopMatches: false,
        error: '',
      }))
      .addCase(getMeilleursParis.fulfilled, (state, { payload }) => {
        let successTopMatches = false;
        const topMatchesMap = new Map(state.meilleursParis.map((m) => [m.id, m]));
        const filterMap = new Map(state.filters.map((f) => ([f.id, f])));
        let allSports = [...state.allsports];
        if (payload?.length > 0) {
          successTopMatches = true;
          allSports = payload;

          payload.forEach((match) => {
            filterMap.set(match.id, {
              id: match.id,
              name: match.name,
              count: match.count,
              icon: match.icon,
            });

            topMatchesMap.set(match.id, {
              ...match,
              categories: match?.categories?.map((cat) => ({
                ...cat,
                tournaments: cat?.tournaments?.map((t) => ({
                  ...t,
                  matches: t?.matches?.map((m) => ({
                    ...m,
                    outcome: m?.outcome?.map((outcome) => ({
                      ...outcome,
                      inBetSlip: false,
                      matchId: m?.id,
                      icon: match?.icon,
                      uniqueId: m?.id + outcome?.name + outcome?.market.name,
                      count: m?.count,
                    })),
                  })),
                })),
              })),
            });
          });

          // updatedTopMatches = updatedTopMatches.filter((match, index, array) => {
          //   const ids = array.map((item) => item.id);
          //   const matchId = match.id;

          //   return ids.indexOf(matchId) === index;
          // });
        }

        if (payload.count) {
          const match = payload;
          successTopMatches = true;
          const currentFilters = [...state.filters];
          const currentTopMatches = [...state.meilleursParis];
          const index = allSports.findIndex((s) => s.id === payload.id);
          if (index > -1) {
            allSports[index] = { ...allSports[index], ...payload };
          }
          const filter = {
            id: match.id,
            name: match.name,
            count: match.count,
            icon: match.icon,
          };

          const filterIndex = currentFilters.findIndex((f) => f.id === filter.id);

          if (filterIndex > -1) {
            currentFilters[filterIndex] = { ...currentFilters[filterIndex], ...filter };
          } else {
            currentFilters.push(filter);
          }

          const topMatch = {
            ...match,
            categories: match?.categories?.map((cat) => ({
              ...cat,
              tournaments: cat?.tournaments?.map((t) => ({
                ...t,
                matches: t?.matches?.map((m) => ({
                  ...m,
                  outcome: m?.outcome?.map((outcome) => ({
                    ...outcome,
                    inBetSlip: false,
                    matchId: m?.id,
                    icon: match?.icon,
                    uniqueId: m?.id + outcome?.name + outcome?.market.name,
                    count: m?.count,
                  })),
                })),
              })),
            })),
          };

          const topMatchIndex = currentTopMatches.findIndex((p) => p.id === topMatch.id);

          if (topMatchIndex > -1) {
            currentTopMatches[topMatchIndex] = { ...currentTopMatches[topMatchIndex], categories: topMatch.categories, count: topMatch.count };
          } else {
            currentTopMatches.push(topMatch);
          }

          return {
            ...state,
            meilleursParis: currentTopMatches,
            successTopMatches,
            allsports: [...allSports],
            isLoading: false,
            filters: currentFilters,
          };
        }

        return {
          ...state,
          meilleursParis: Array.from(topMatchesMap.values()),
          successTopMatches,
          allsports: [...allSports],
          isLoading: false,
          filters: Array.from(filterMap.values()),
        };
      })
      .addCase(getMeilleursParis.rejected, (state) => ({
        ...state,
        isLoading: false,
        successTopMatches: false,
        error: msg29,
      }));
  },
});

export const {
  selectItem, unSelectFromTopmatch, resetMeilleurParis,
  setAllToFalse,
} = meilleursParisSlice.actions;

export default meilleursParisSlice.reducer;
